import getValue from 'lodash/get';
import isFinite from 'lodash/isFinite';
import { getGooglePlaceDetails } from 'commons/utils/geo';
import { getQueryParams } from 'commons/utils/uri';

function getTrialLocation({
  locationName = null,
  latitude = null,
  longitude = null,
  country = null,
} = {}) {
  latitude = Number(latitude);
  longitude = Number(longitude);

  if (!isFinite(latitude)) {
    latitude = null;
  }

  if (!isFinite(longitude)) {
    longitude = null;
  }

  if (!locationName || !latitude || !longitude) {
    return null;
  }

  if (typeof locationName !== 'string') {
    return null;
  }

  return {
    locationName,
    geoLat: latitude.toFixed(4),
    geoLng: longitude.toFixed(4),
    country,
  };
}

function getValidMedicationCondition(condition) {
  if (typeof condition !== 'string') {
    return null;
  }

  return condition;
}

function initTrialSearch() {
  const defaultCondition = this.defaultCondition;
  const defaultLocation = this.defaultLocation;

  const defaultLocationName = getValue(defaultLocation, 'locationName', null);
  const defaultLatitude = getValue(defaultLocation, 'latitude', null);
  const defaultLongitude = getValue(defaultLocation, 'longitude', null);
  const defaultCountry = getValue(defaultLocation, 'country', null);

  const queryParams = getQueryParams();

  const medicalCondition = getValue(queryParams, 'q', defaultCondition);

  const locationName = getValue(queryParams, 'place', defaultLocationName);
  const latitude = getValue(queryParams, 'geo_lat', defaultLatitude);
  const longitude = getValue(queryParams, 'geo_lng', defaultLongitude);
  const country = getValue(queryParams, 'user_country', defaultCountry);

  const validMedicalCondition = getValidMedicationCondition(medicalCondition);

  const validTrialLocation = getTrialLocation({
    locationName,
    latitude,
    longitude,
    country,
  });

  this.trialLocation(validTrialLocation);
  validTrialLocation && this.trialLocationInput(locationName); // Input text in case of valid location

  this.medicalCondition(validMedicalCondition);
}

function handleMedicalCondition(condition) {
  this.medicalCondition(condition);
  let params = {condition:condition}
  if(this.widgetId){
       params.widget = this.widgetId
  }

  $.ajax({
      url: `/clinical-trials/listings/general_autocomplete/`,
      method:`post`,
      data: params,
    })

}

function setConditionLoading(loading) {
  this.isConditionLoading(loading);
}

function handleLocationChange(autoComplete) {
  const place = autoComplete.getPlace();
  const placeDetails = getGooglePlaceDetails(place);

  if (placeDetails) {
    const {
      locationName,
      latitude,
      longitude,
      countryName: country,
    } = placeDetails;

    const trialLocation = getTrialLocation({
      locationName,
      latitude,
      longitude,
      country,
    });

    this.trialLocation(trialLocation);
    this.trialLocationInput(locationName);
    this.hasLocationError(false);
  } else {
    this.trialLocation(null);
  }
}

function isValidLocation() {
  const trialLocation = this.trialLocation();
  const trialLocationInput = this.trialLocationInput();
  const selectedLocationName = getValue(trialLocation, 'locationName', null);

  return !trialLocationInput || selectedLocationName === trialLocationInput;
}

function handleLocationInputChange(locationInput) {
  const locationSelected = this.trialLocation();
  const locationName = getValue(locationSelected, 'locationName', null);

  if (locationName && locationName !== locationInput) {
    this.trialLocation(null);
  }

  if (!locationInput) {
    this.hasLocationError(false);
  }
}

function handleValueChanged() {
  this.isSearchDisabled(false);
}

function onSearchSubmit() {
  const medicalCondition = this.medicalCondition();
  const canSearchStudy = this.canSearchStudy();
  const isValidLocation = this.isValidLocation();

  this.hasLocationError(!isValidLocation);

  if (canSearchStudy) {
    return true;
  }

  if (!medicalCondition) {
    this.$medicalConditionRef.focus();
  }

  return false;
}

function TrialSearchViewModel({
  defaultCondition = null,
  defaultLocation = null,
  widgetId = null,
}) {
  const self = this;

  self.$medicalConditionRef = $('#search-medical-conditions');
  self.$withinRadiusRef = $('#location-radius-dropdown');
  self.defaultCondition = defaultCondition;
  self.defaultLocation = defaultLocation;
  self.widgetId = widgetId

  self.medicalCondition = ko.observable();
  self.trialLocation = ko.observable();
  self.trialLocationInput = ko.observable();
  self.isConditionLoading = ko.observable(false);
  self.hasLocationError = ko.observable(false);
  self.isSearchDisabled = ko.observable(true);

  self.initTrialSearch = initTrialSearch.bind(self);
  self.handleMedicalCondition = handleMedicalCondition.bind(self);
  self.handleLocationChange = handleLocationChange.bind(self);
  self.handleLocationInputChange = handleLocationInputChange.bind(self);
  self.onSearchSubmit = onSearchSubmit.bind(self);
  self.isValidLocation = isValidLocation.bind(self);
  self.setConditionLoading = setConditionLoading.bind(self);
  self.handleValueChanged = handleValueChanged.bind(self);

  self.canSearchStudy = ko.computed(function () {
    return !!this.medicalCondition() && this.isValidLocation();
  }, self);

  self.initTrialSearch();

  self.trialLocationInput.subscribe(self.handleLocationInputChange);
  self.trialLocationInput.subscribe(self.handleValueChanged);
  self.medicalCondition.subscribe(self.handleValueChanged);

  self.$withinRadiusRef.on('changed.bs.select', function () {
    self.handleValueChanged();
  });
}

export default TrialSearchViewModel;
